import React from "react";
import ClientSearchSelect from "../../../components/Search/ClientSearchSelect";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import style from "./ClientInfo.module.scss";
import { IoMdPerson } from "react-icons/io";
const ClientInfo = ({ car, isEditing, onClientChange }) => {
  return (
    <div className={style.clientCard}>
      <span className={style.icon}>
              <IoMdPerson />
        </span>  

      <div className={style.clientDetails}>
        {isEditing ? (
          <ClientSearchSelect
            placeholder="Выберите клиента"
            onClientSelect={(clientId) => onClientChange(clientId)}
            currentClient={car.client || null}
          />
        ) : (
          <>
            <div className={style.clientName}>
              {car.client?.fullname || "Нет владельца"}
            </div>
            <div className={style.clientPhone}>
              {car.client?.phone_number || "Нет телефона"}
            </div>
          </>
        )}
      </div>

      {car.client?.id && (
        <Link to={`/clients/client/${car.client.id}`} className={style.linkIcon}>
          <FaArrowRight size={20} />
        </Link>
      )}
    </div>
  );
};

export default ClientInfo;
